import { createContext, useContext, useState } from "react";

const LangContext = createContext(null);

export const translations = {
  de: {
    nav_show: "Die Show",
    nav_tickets: "Tickets",
    nav_merch: "Merch",
    nav_friends: "Friends",
    nav_sponsors: "Sponsoren",
    nav_press: "Presse",
    nav_travel: "Anreise",
    nav_admin: "Backstage",
    nav_cta: "Tickets sichern",
    hero_kicker: "Latschenwirt am Untersberg präsentiert · Krampus-Show 2026",
    hero_line1: "DIE IGNORANZ",
    hero_line2: "KOSTET.",
    hero_h1: "Krampus-Show 2026 beim Latschenwirt in Großgmain",
    hero_fact: "20. & 21. November 2026 · Einlass 17:30 Uhr · Latschenwirt-Arena, Großgmain bei Salzburg",
    hero_sub: "Die größte Krampus-Show im Latschenwirt ist live, emotional, überwältigend und voller Gänsehautmomente. Erlebt eine theatralische Live-Show mit einer metaphorischen Übersetzung in die globale und gesellschaftliche Entwicklung unserer heutigen Zeit. Wer die guten Werte mit Füßen tritt, wer mit Ignoranz, Neid, Gier und überbordenden Egos lebt, kommt in die Teufelsküche. Alle anderen feiern ein Fest des Brauchtums mit uns.",
    hero_cta1: "Tickets sichern",
    hero_cta2: "Trailer der Nacht",
    hero_meta: "20. & 21. November 2026 · Latschenwirt-Arena · 5084 Großgmain",
    hero_urgency: "Nur zwei Nächte – die Tickets sind jedes Jahr früh ausverkauft",
    marquee_items: "Feuer · Fackeln · Verschneite Wälder · Die Horde · Der schwebende Engel · Der Teufel · Pyrotechnik · Flying Bulls · Mythos Untersberg · ",
    intro_kicker: "Intro",
    intro_title: "Wenn der Berg ruft, antwortet das Feuer.",
    intro_text: "IN CULINA DIABOLI entführt euch in eine Nacht zwischen Brauchtum und Fantasie. Über hundert Krampusse, geheimnisvolle Gestalten und internationale Schauspieler bevölkern die Szenerie. Krampusse gleiten aus dem Nachthimmel herab, während spektakuläre Stunts und eigens erschaffene Feuerbilder die Grenzen des Wirklichen verschwimmen lassen.",
    intro_text2: "Doch die Teufelsküche liegt näher, als wir glauben. Sie wächst dort, wo Gier die Güte verdrängt, Neid die Herzen verdunkelt und das eigene Ich keinen Platz mehr für andere lässt. So erzählt diese Nacht auch von unserer Welt – und von den Werten, die uns verbinden.",
    intro_text3: "Folgt dem Ruf des Berges. Feiert mit uns ein Fest des Brauchtums, das unter die Haut geht und noch lange in euch nachklingt.",
    acts_kicker: "Die Inszenierung",
    acts_title: "Akte der Nacht",
    act_horde_t: "Die Horde",
    act_horde_d: "Die Hinterreiter Krampusse ziehen mit Fackeln durch Schnee und Dunkelheit – Masken, Fell, Kettenrasseln.",
    act_stage_t: "Die große Bühne",
    act_stage_d: "Theater in XXL: Licht, Nebel und ein Bühnenbild, das die Arena zum Filmset macht.",
    act_angel_t: "Der schwebende Engel",
    act_angel_d: "Der fliegende Engel schwebt über der Arena – Licht in der dunkelsten Nacht des Jahres.",
    act_devil_t: "Der Teufel",
    act_devil_d: "Theatralisch, monumental, unheimlich nah – der Teufel persönlich tritt aus dem Rauch.",
    act_pyro_t: "Pyro & Feuer",
    act_pyro_d: "Feuer-Inszenierungen und Pyrotechnik, die den Nachthimmel über Großgmain in Flammen tauchen.",
    act_flying_t: "Flying Bulls",
    act_flying_d: "Die fliegenden Krampusse der Flying Bulls – Stunt-Action über den Köpfen des Publikums.",
    act_mask_t: "Maske & Wolfschwang Alm",
    act_mask_d: "Auf der Wolfschwang Alm werden Darsteller und Stuntteams geschminkt – Backstage des Mythos.",
    act_wagner_t: "Vinzenz Wagner",
    act_wagner_d: "Schauspieler Vinzenz Wagner führt durch die Erzählung der Nacht – Stimme und Seele der Show.",
    mountain_kicker: "Der Kraftplatz",
    mountain_title: "Mythos Untersberg",
    mountain_text: "Kein Berg der Alpen ist so von Sagen umwoben wie der Untersberg bei Großgmain. Schlafende Kaiser in verborgenen Höhlen, Zeitphänomene, wilde Geister – man sagt dem Berg magische Kraft nach. Die Krampus-Show holt diese Mystik aus der Legende mitten in die Arena.",
    mountain_cta: "Mehr über den Ort",
    tickets_kicker: "Der Vorverkauf",
    tickets_title: "Wähle deinen Platz in der Hölle",
    tickets_sub: "Vom Open-Air-Rang bis zum VIP-Tisch in den Latschenwirt-Stuben.",
    tickets_all: "Alle Tickets",
    merch_kicker: "Merch Drops",
    merch_title: "Trag die Legende",
    merch_sub: "Limitierte Drops im Kinoplakat-Stil. Wenn sie weg sind, sind sie weg.",
    merch_all: "Merch Shop",
    merch_collection: "Die gesamte Kollektion",
    friends_kicker: "Krampus-Show Friends",
    friends_title: "Die Wall der Freunde",
    friends_sub: "Menschen, Momente, Content – gefeatured aus unserer Community.",
    friends_all: "Alle Friends",
    sponsors_kicker: "Partner der Nacht",
    sponsors_title: "Unsere Sponsoren",
    sponsors_sub: "Mit Wertschätzung und Krampus-Coolness in Szene gesetzt.",
    sponsors_all: "Sponsor werden",
    newsletter_kicker: "Der innere Kreis",
    newsletter_title: "News aus der Unterwelt",
    newsletter_sub: "Show-Termine, Ticket-Releases, Merch-Drops – zuerst per Mail.",
    newsletter_placeholder: "deine@email.at",
    newsletter_cta: "Eintragen",
    newsletter_success: "Willkommen im Kreis! Bitte bestätige deine E-Mail im Postfach.",
    newsletter_error: "Das hat nicht geklappt. Bitte versuch es erneut.",
    footer_tagline: "Ein Genussrefugium am Fuße des Untersberges.",
    footer_contact: "Kontakt",
    footer_explore: "Entdecken",
    footer_legal: "Mit Liebe & Feuer gemacht am Untersberg.",
    legal_privacy: "Datenschutz",
    legal_widerruf: "Widerruf",
    buy: "Jetzt kaufen",
    soldout: "Ausverkauft",
    contact_us: "Kontaktiere uns unter office@latschenwirt.at",
    on_request: "Auf Anfrage",
    cta_vip_tisch: "VIP Tisch sichern",
    cta_vip_sponsor: "VIP Paket sichern",
    mail_subj_vip_tisch: "VIP-Tisch Anfrage – Krampus-Show 2026",
    mail_subj_vip_sponsor: "VIP- & Sponsorenpaket Anfrage – Krampus-Show 2026",
    share: "Teilen",
    shared: "Link kopiert!",
    from_price: "ab",
    press_kicker: "Medienbereich",
    press_title: "Presse & Downloads",
    press_sub: "Pressetexte, Bild- und Videoarchive für die redaktionelle Berichterstattung.",
    press_download: "Öffnen / Download",
    sponsors_hero_t: "Werde Teil der Legende",
    sponsors_hero_d: "Vier Kategorien. Eine Bühne. Dein Branding im Fackelschein.",
    tier_hoellenfuerst: "Höllenfürst",
    tier_hoellenfuerst_d: "Event- & Logo-Hauptsponsor. Dein Logo auf Plakat, Bühne und in jedem Feuerstrahl der Kommunikation.",
    tier_feuertitan: "Feuertitan",
    tier_feuertitan_d: "XL-Sponsor. Prominente Präsenz in der Arena und auf allen Kanälen.",
    tier_kettenmeister: "Kettenmeister",
    tier_kettenmeister_d: "Medium-Sponsor. Sichtbar, wo das Kettenrasseln am lautesten ist.",
    tier_funkenfreund: "Funkenfreund",
    tier_funkenfreund_d: "Small-Sponsor. Ein Funke, der zählt – mit Nennung und Dank.",
    apply_title: "Sponsor werden",
    apply_mail_hint: "Schick uns dein Interesse direkt per E-Mail an office@latschenwirt.at – wir melden uns mit allen Informationen zu den Sponsoring-Möglichkeiten bei dir.",
    apply_company: "Firma",
    apply_contact: "Ansprechpartner:in",
    apply_email: "E-Mail",
    apply_tier: "Kategorie",
    apply_message: "Nachricht",
    apply_cta: "Sponsor werden",
    apply_success: "Deine Bewerbung ist eingegangen – wir melden uns in Kürze!",
    apply_error: "Senden fehlgeschlagen. Bitte versuch es erneut.",
    friends_hero_t: "Krampus-Show Friends",
    friends_hero_d: "Eine Social Wall aus Feuer, Freundschaft und Fackellicht.",
    merch_hero_t: "Der Merch-Shop",
    merch_hero_d: "Drops im Kinoplakat-Stil. Limitiert. Begehrt.",
    tickets_hero_t: "Tickets & Erlebnisse",
    tickets_hero_d: "Arena Open Air, geschützte VIP Area, VIP-Tische in den Latschenwirt-Stuben und Sponsorpakete.",
    tickets_banner: "Shows: Fr 20.11. & Sa 21.11.2026 · Sei schnell – die Tickets sind immer früh ausverkauft.",
    payment_success_t: "Der Pakt ist besiegelt.",
    payment_success_d: "Deine Zahlung war erfolgreich. Wir sehen uns im Fackelschein!",
    payment_pending: "Zahlung wird bestätigt…",
    payment_cancel_t: "Der Vorhang bleibt vorerst zu.",
    payment_cancel_d: "Die Zahlung wurde abgebrochen. Dein Platz wartet noch.",
    back_home: "Zurück zur Startseite",
    back_tickets: "Zurück zu den Tickets",
    admin_login_t: "Backstage Zutritt",
    admin_login_d: "Nur für die Show-Direktion.",
    admin_login_cta: "Einloggen",
    admin_login_error: "Login fehlgeschlagen.",
    admin_dashboard: "Backstage-Dashboard",
    admin_products: "Produkte",
    admin_sponsors: "Sponsoren",
    admin_friends: "Friends",
    admin_press: "Presse",
    admin_newsletter: "Newsletter",
    admin_applications: "Anfragen",
    admin_orders: "Bestellungen",
    admin_logout: "Logout",
    admin_save: "Speichern",
    admin_add: "Neu anlegen",
    admin_edit: "Bearbeiten",
    admin_delete: "Löschen",
    admin_saved: "Gespeichert",
    admin_deleted: "Gelöscht",
    qty: "Anzahl",
    reel_kicker: "Showreel",
    reel_title: "Aus dem Archiv der Nacht",
    reel_sub: "Echte Sequenzen der Krampus-Show – Closeups und Momente im Cinema-Format.",
    reel_sound: "Sound",
    film_kicker: "Der Film",
    film_title: "DAS AFTERMOVIE",
    film_sub: "Ein Jahr Feuer, Rauch und Legenden – das offizielle Aftermovie der Krampus-Show am Untersberg.",
    film_hint: "Klicken zum Abspielen – mit Ton",
    gallery_alt: "Live-Impression der Krampus-Show 2026 beim Latschenwirt, Foto",
    voices_kicker: "Stimmen",
    voices_title: "Publikums- & Pressestimmen",
    voices_sub: "Was Menschen und Medien über die Nacht am Untersberg sagen.",
    voice1_q: "Es ist die krasseste Show mit Krampussen, die ich je erlebt habe.",
    voice1_a: "Michaela, Salzburg",
    voice2_q: "Die Inszenierung ist Hollywood-reif und überwältigend. Das gab's noch nie.",
    voice2_a: "Anton, Hallein",
    voice3_q: "Feuer, Fell und Gänsehaut – wir kommen jedes Jahr wieder.",
    voice3_a: "Sabine, Freilassing",
    voice4_q: "Kein Kino der Welt kommt an diese Nacht heran. Absoluter Kultur-Blockbuster.",
    voice4_a: "Familie Gruber, Großgmain",
    cd_label: "Showstart · 20. November 2026 · Einlass: 17:30",
    cd_days: "Tage",
    cd_hours: "Stunden",
    cd_min: "Minuten",
    cd_sec: "Sekunden",
    admin_voices: "Stimmen",
    badge_cta: "Jetzt Ticket sichern",
    badge_fri: "Freitag",
    badge_sat: "Samstag",
    badge_left: "Nur noch {n} Tickets",
    cookie_kicker: "Cookies & Datenschutz",
    cookie_text: "Wir nutzen Cookies, um die Website zu betreiben. Mit deiner Zustimmung laden wir zusätzlich Statistik (Google Analytics) und Marketing-Dienste – erst dann werden Daten an Dritte übertragen. Details in der",
    cookie_privacy: "Datenschutzerklärung",
    cookie_accept_all: "Alle akzeptieren",
    cookie_necessary: "Nur notwendige",
    cookie_settings: "Einstellungen",
    cookie_save: "Auswahl speichern",
    cookie_cat_necessary: "Notwendig",
    cookie_cat_necessary_d: "Technisch erforderlich – ohne sie funktioniert die Website nicht (z. B. Speicherung deiner Cookie-Auswahl).",
    cookie_cat_stats: "Statistik",
    cookie_cat_stats_d: "Google Analytics mit IP-Anonymisierung – hilft uns zu verstehen, wie die Website genutzt wird. Wird nur mit deiner Zustimmung geladen.",
    cookie_cat_marketing: "Marketing",
    cookie_cat_marketing_d: "Dienste für personalisierte Inhalte und Werbung. Aktuell setzen wir keine Marketing-Cookies.",
    cookie_always_on: "Immer aktiv",
  },
  en: {
    nav_show: "The Show",
    nav_tickets: "Tickets",
    nav_merch: "Merch",
    nav_friends: "Friends",
    nav_sponsors: "Sponsors",
    nav_press: "Press",
    nav_travel: "Getting There",
    nav_admin: "Backstage",
    nav_cta: "Get Tickets",
    hero_kicker: "Latschenwirt at Mount Untersberg presents · Krampus-Show 2026",
    hero_line1: "DIE IGNORANZ",
    hero_line2: "KOSTET.",
    hero_h1: "Krampus Show 2026 at the Latschenwirt in Grossgmain",
    hero_fact: "20 & 21 November 2026 · Doors open 5:30 pm · Latschenwirt Arena, Grossgmain near Salzburg",
    hero_sub: "The biggest Krampus show at the Latschenwirt is live, emotional, overwhelming and full of goosebump moments. Experience a theatrical live show that metaphorically mirrors the global and social developments of our time. Those who trample good values, who live with ignorance, envy, greed and bloated egos, end up in the devil's kitchen. Everyone else celebrates a festival of tradition with us.",
    hero_cta1: "Get Tickets",
    hero_cta2: "Trailer of the Night",
    hero_meta: "20 & 21 November 2026 · Latschenwirt Arena · 5084 Großgmain",
    hero_urgency: "Only two nights – tickets sell out early every year",
    marquee_items: "Fire · Torches · Snowy Forests · The Horde · The Floating Angel · The Devil · Pyrotechnics · Flying Bulls · Myth of Untersberg · ",
    intro_kicker: "Intro",
    intro_title: "When the mountain calls, the fire answers.",
    intro_text: "IN CULINA DIABOLI carries you away into a night between folklore and fantasy. Over a hundred Krampusse, mysterious figures and international actors populate the scenery. Krampusse glide down from the night sky while spectacular stunts and specially created fire images blur the boundaries of reality.",
    intro_text2: "Yet the devil's kitchen is closer than we think. It grows where greed displaces goodness, envy darkens hearts and the ego leaves no room for others. And so this night also tells of our world – and of the values that bind us together.",
    intro_text3: "Follow the call of the mountain. Celebrate with us a festival of tradition that gets under your skin and resonates long after.",
    acts_kicker: "The Staging",
    acts_title: "Acts of the Night",
    act_horde_t: "The Horde",
    act_horde_d: "The Hinterreiter Krampusse march with torches through snow and darkness – masks, fur, rattling chains.",
    act_stage_t: "The Grand Stage",
    act_stage_d: "Theatre in XXL: light, fog and a set design that turns the arena into a film set.",
    act_angel_t: "The Floating Angel",
    act_angel_d: "The flying angel hovers above the arena – light in the darkest night of the year.",
    act_devil_t: "The Devil",
    act_devil_d: "Theatrical, monumental, eerily close – the devil himself steps out of the smoke.",
    act_pyro_t: "Pyro & Fire",
    act_pyro_d: "Fire staging and pyrotechnics setting the night sky above Großgmain ablaze.",
    act_flying_t: "Flying Bulls",
    act_flying_d: "The flying Krampusse of the Flying Bulls – stunt action above the audience's heads.",
    act_mask_t: "Mask & Wolfschwang Alm",
    act_mask_d: "At the Wolfschwang Alm performers and stunt teams get their makeup – backstage of the myth.",
    act_wagner_t: "Vinzenz Wagner",
    act_wagner_d: "Actor Vinzenz Wagner guides through the narrative of the night – voice and soul of the show.",
    mountain_kicker: "The Power Place",
    mountain_title: "Myth of Untersberg",
    mountain_text: "No mountain in the Alps is wrapped in as many legends as the Untersberg near Großgmain. Sleeping emperors in hidden caves, time phenomena, wild spirits – the mountain is said to hold magical power. The Krampus Show pulls this mysticism from legend straight into the arena.",
    mountain_cta: "More about the place",
    tickets_kicker: "Pre-Sale",
    tickets_title: "Choose your seat in hell",
    tickets_sub: "From open-air ranks to the VIP table in the Latschenwirt parlours.",
    tickets_all: "All Tickets",
    merch_kicker: "Merch Drops",
    merch_title: "Wear the Legend",
    merch_sub: "Limited drops in movie-poster style. Once they're gone, they're gone.",
    merch_all: "Merch Shop",
    merch_collection: "The full collection",
    friends_kicker: "Krampus-Show Friends",
    friends_title: "The Wall of Friends",
    friends_sub: "People, moments, content – featured from our community.",
    friends_all: "All Friends",
    sponsors_kicker: "Partners of the Night",
    sponsors_title: "Our Sponsors",
    sponsors_sub: "Staged with appreciation and Krampus coolness.",
    sponsors_all: "Become a Sponsor",
    newsletter_kicker: "The Inner Circle",
    newsletter_title: "News from the Underworld",
    newsletter_sub: "Show dates, ticket releases, merch drops – first by email.",
    newsletter_placeholder: "you@email.com",
    newsletter_cta: "Sign Up",
    newsletter_success: "Welcome to the circle! Please confirm your email in your inbox.",
    newsletter_error: "Something went wrong. Please try again.",
    footer_tagline: "A refuge of indulgence at the foot of Mount Untersberg.",
    footer_contact: "Contact",
    footer_explore: "Explore",
    footer_legal: "Made with love & fire at Mount Untersberg.",
    legal_privacy: "Privacy",
    legal_widerruf: "Cancellation",
    buy: "Buy Now",
    soldout: "Sold out",
    contact_us: "Contact us at office@latschenwirt.at",
    on_request: "On request",
    cta_vip_tisch: "Reserve VIP Table",
    cta_vip_sponsor: "Secure VIP Package",
    mail_subj_vip_tisch: "VIP table inquiry – Krampus Show 2026",
    mail_subj_vip_sponsor: "VIP & sponsor package inquiry – Krampus Show 2026",
    share: "Share",
    shared: "Link copied!",
    from_price: "from",
    press_kicker: "Media Area",
    press_title: "Press & Downloads",
    press_sub: "Press releases, image and video archives for editorial coverage.",
    press_download: "Open / Download",
    sponsors_hero_t: "Become Part of the Legend",
    sponsors_hero_d: "Four categories. One stage. Your branding in torchlight.",
    tier_hoellenfuerst: "Hell Sovereign",
    tier_hoellenfuerst_d: "Event & logo main sponsor. Your logo on poster, stage and in every fire beam of communication.",
    tier_feuertitan: "Fire Titan",
    tier_feuertitan_d: "XL sponsor. Prominent presence in the arena and on all channels.",
    tier_kettenmeister: "Chain Master",
    tier_kettenmeister_d: "Medium sponsor. Visible where the chains rattle loudest.",
    tier_funkenfreund: "Spark Friend",
    tier_funkenfreund_d: "Small sponsor. A spark that counts – with mention and thanks.",
    apply_title: "Become a Sponsor",
    apply_mail_hint: "Send us your interest directly by email to office@latschenwirt.at – we will get back to you with all sponsorship details.",
    apply_company: "Company",
    apply_contact: "Contact person",
    apply_email: "Email",
    apply_tier: "Category",
    apply_message: "Message",
    apply_cta: "Become a Sponsor",
    apply_success: "Your application is in – we'll get back to you shortly!",
    apply_error: "Sending failed. Please try again.",
    friends_hero_t: "Krampus-Show Friends",
    friends_hero_d: "A social wall of fire, friendship and torchlight.",
    merch_hero_t: "The Merch Shop",
    merch_hero_d: "Drops in movie-poster style. Limited. Desired.",
    tickets_hero_t: "Tickets & Experiences",
    tickets_hero_d: "Arena open air, protected VIP area, VIP tables in the Latschenwirt parlours and sponsor packages.",
    tickets_banner: "Shows: Fri 20 Nov & Sat 21 Nov 2026 · Be quick – tickets always sell out early.",
    payment_success_t: "The pact is sealed.",
    payment_success_d: "Your payment was successful. See you in the torchlight!",
    payment_pending: "Confirming payment…",
    payment_cancel_t: "The curtain stays closed for now.",
    payment_cancel_d: "The payment was cancelled. Your seat is still waiting.",
    back_home: "Back to Home",
    back_tickets: "Back to Tickets",
    admin_login_t: "Backstage Access",
    admin_login_d: "For the show direction only.",
    admin_login_cta: "Log In",
    admin_login_error: "Login failed.",
    admin_dashboard: "Backstage Dashboard",
    admin_products: "Products",
    admin_sponsors: "Sponsors",
    admin_friends: "Friends",
    admin_press: "Press",
    admin_newsletter: "Newsletter",
    admin_applications: "Applications",
    admin_orders: "Orders",
    admin_logout: "Logout",
    admin_save: "Save",
    admin_add: "Create New",
    admin_edit: "Edit",
    admin_delete: "Delete",
    admin_saved: "Saved",
    admin_deleted: "Deleted",
    qty: "Quantity",
    reel_kicker: "Showreel",
    reel_title: "From the Archive of the Night",
    reel_sub: "Real sequences of the Krampus-Show – close-ups and moments in cinema format.",
    reel_sound: "Sound",
    film_kicker: "The Film",
    film_title: "THE AFTERMOVIE",
    film_sub: "A year of fire, smoke and legends – the official aftermovie of the Krampus Show at Mount Untersberg.",
    film_hint: "Click to play – with sound",
    gallery_alt: "Live impression of the Krampus Show 2026 at the Latschenwirt, photo",
    voices_kicker: "Voices",
    voices_title: "Audience & Press Voices",
    voices_sub: "What people and media say about the night at Mount Untersberg.",
    voice1_q: "It is the wildest Krampus show I have ever experienced.",
    voice1_a: "Michaela, Salzburg",
    voice2_q: "The staging is Hollywood-ready and overwhelming. There has never been anything like it.",
    voice2_a: "Anton, Hallein",
    voice3_q: "Fire, fur and goosebumps – we come back every year.",
    voice3_a: "Sabine, Freilassing",
    voice4_q: "No cinema in the world comes close to this night. A true cultural blockbuster.",
    voice4_a: "Family Gruber, Großgmain",
    cd_label: "Show start · 20 November 2026 · Doors open: 5:30 pm",
    cd_days: "Days",
    cd_hours: "Hours",
    cd_min: "Minutes",
    cd_sec: "Seconds",
    admin_voices: "Voices",
    badge_cta: "Get your ticket now",
    badge_fri: "Friday",
    badge_sat: "Saturday",
    badge_left: "Only {n} left",
    cookie_kicker: "Cookies & Privacy",
    cookie_text: "We use cookies to run this website. With your consent we additionally load analytics (Google Analytics) and marketing services – only then is data shared with third parties. Details in our",
    cookie_privacy: "privacy policy",
    cookie_accept_all: "Accept all",
    cookie_necessary: "Only necessary",
    cookie_settings: "Settings",
    cookie_save: "Save selection",
    cookie_cat_necessary: "Necessary",
    cookie_cat_necessary_d: "Technically required – the website does not work without them (e.g. storing your cookie choice).",
    cookie_cat_stats: "Statistics",
    cookie_cat_stats_d: "Google Analytics with IP anonymisation – helps us understand how the website is used. Only loaded with your consent.",
    cookie_cat_marketing: "Marketing",
    cookie_cat_marketing_d: "Services for personalised content and advertising. We currently do not set any marketing cookies.",
    cookie_always_on: "Always on",
  },
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("de");
  const t = (key) => translations[lang][key] ?? key;
  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
